import { render, staticRenderFns } from "./ProductWarranty.vue?vue&type=template&id=4276e22a&scoped=true&"
import script from "./ProductWarranty.vue?vue&type=script&lang=js&"
export * from "./ProductWarranty.vue?vue&type=script&lang=js&"
import style0 from "./ProductWarranty.vue?vue&type=style&index=0&id=4276e22a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4276e22a",
  null
  
)

export default component.exports